import React, { useMemo } from 'react';
import noop from 'lodash/noop';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container/src/index.tsx';
import { useBacklogSelector } from '../../../state/index.tsx';
import { getProjectKey } from '../../../state/selectors/app/index.tsx';
import { getBaseLevelCardTypes } from '../../../state/selectors/card-type/index.tsx';
import type { AiWorkCreatePanelEntryPointSubject } from '../inline-card-create/ai-work-create/types.tsx';

type Props = {
	subject: AiWorkCreatePanelEntryPointSubject;
};

export const AiWorkCreatePanel = ({ subject }: Props) => {
	const projectKey = useBacklogSelector(getProjectKey);
	const baseLevelCardTypes = useBacklogSelector(getBaseLevelCardTypes).map(
		({ id, hasRequiredFields, ...rest }) => ({
			...rest,
			id: String(id),
			hasRequiredField: Boolean(hasRequiredFields),
			hasEpicLinkField: true,
			hasWorkflowValidators: false,
			requiredFields: [],
		}),
	);
	// TODO: CRCS-1392 to implement onCreate, onDiscard, onEdit
	const runtimeProps = useMemo(
		() => ({
			onCreate: noop,
			onEdit: noop,
			availableIssueTypes: baseLevelCardTypes,
			projectKey,
		}),
		[projectKey, baseLevelCardTypes],
	);

	return (
		<JiraEntryPointContainer
			entryPointReferenceSubject={subject}
			id="aiWorkCreatePanel"
			packageName="backlog"
			errorFallback="unmount"
			teamName="Crocs"
			runtimeProps={runtimeProps}
		/>
	);
};
